export default {
  date: `Date de rendez-vous actuelle : {date}`,
  duration: 'Date de rendez-vous actuelle {date}, durée {duration} minutes',
  subtitle:
    "Votre rendez-vous devrait durer environ {duration} min. Sélectionnez un créneau disponible pour planifier votre rendez-vous",
  calendarOptions: {
    daysLabel: ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"],
    monthsLabel: [
      "Jan",
      "Fev",
      "Mar",
      "Avr",
      "Mai",
      "Juin",
      "Juil",
      "Aoû",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    backgroundColors: "#CEEBE9",
    loadingText: "Chargement",
    emptyDate: "Pas de dates pour cette semaine",
  },
  description: 'Description',
  select: {
    defaultDuration: 'Sélectionner une durée',
    durations: [
      {display_name: '30 minutes', value: 30},
      {display_name: '45 minutes', value: 45},
      {display_name: '60 minutes', value: 60},
      {display_name: '75 minutes', value: 75},
      {display_name: '90 minutes', value: 90},
      {display_name: '105 minutes', value: 105},
      {display_name: '120 minutes', value: 120},
    ],
    defaultLanguage: 'Sélectionner une langue',
    languages: [
      {
        display_name: 'Français',
        value: 'FR',
      },
      {
        display_name: 'Anglais',
        value: 'EN',
      },
      {
        display_name: 'Espagnol',
        value: 'ES'
      },
      {
        display_name: 'Arabe',
        value: 'AR'
      },
    ],
    defaultOperator: 'Sélectionner un expert',
    dateTypeSelected: [
      {
        display_name: 'Modifier le rendez-vous',
        value: 'date-time',
      },
      {
        display_name: 'Replanifier un rendez-vous',
        value: 'scheduled',
      },
    ],
  },
  label: {
    meetingDate: 'Date de rendez-vous : ',
  },
  operator: "<b>avec l'expert</b><br>{firstName} {lastName}",
  wish: "Vous souhaitez réserver un rendez-vous le : ",
  infoDate: "{date} de {start} à {end}",
  booking: "Enregistrer le RDV",
  refreshScheduled: 'Cliquez sur le bouton pour afficher le planning.',
  confirmDate:
    '<div class="nxt-confirm__meeting__calendar__content__item"><div class="nxt-confirm__meeting__calendar__content__item__month">{month}</div><div class="nxt-confirm__meeting__calendar__content__item__day">{day}</div></div><div class="nxt-confirm__meeting__calendar__content__item">{weekday} {day} {month}<br>de {hoursStart} à {hoursEnd}</div>',
  deleteLock: {
    title: 'Attention',
    message: 'Cela libérera le créneau pré-bloqué du {date} avec <b>{firstName} {lastName}</b>. Continuer ?',
    confirm: 'Oui',
    cancel: 'Non',
  },
  fields: {
    operators: {
      required: 'Le champ expert est obligatoire.',
    },
    type: {
      required: 'Le champ type de rendez-vous est obligatoire.'
    },
    language: {
      required: 'Le champ langue est obligatoire.',
    },
    duration: {
      required: 'Le champ duré est obligatoire.',
    },
    dateType: {
      required: 'Choisissez un type de modification du rendez-vous ci-dessus.'
    },
    date: {
      required: 'Le champ « Sélectionner un date » est obligatoire.',
    },
  },
};
